import React, { useMemo } from 'react'

import { string, array, bool } from 'prop-types'

import BrowseAllButton from 'Pods/Shared/BrowseAllButton'
import DesignerModel from 'Pods/Shared/PrintModels/components/DesignerModel'

import useBreakpoint from 'Utils/useBreakpoint'

import ModelScrollList from './ModelScrollList'

function PrintModelsBase({
  models,
  title,
  mobileTitle = '',
  description,
  link,
  className = '',
  buttonText,
  isHydrated = true,
}) {
  const breakpoint = useBreakpoint()

  const filteredModels = useMemo(() => {
    if (!models || models.length === 0) return []
    if (!isHydrated) return models

    switch (breakpoint) {
      case 'sm':
        return models.slice(0, 6)
      case 'md':
      case 'lg':
        return models.slice(0, 8)
      default:
        return models
    }
  }, [models, breakpoint, isHydrated])

  if (filteredModels.length === 0) {
    return null
  }

  const displayTitle = breakpoint === 'sm' || breakpoint === 'xs'
    ? (mobileTitle || title)
    : title

  return (
    <div className={`printable-section ${className}`}>
      <div className="printable-models__header">
        <div className="printable-models__title-group">
          <h2 className="printable-models__title">
            {displayTitle}
          </h2>
          <span className="printable-models__description">{description}</span>
        </div>
        <BrowseAllButton href={link} className="printable-browse-all-desktop" text={buttonText} />
      </div>

      {/* Grid view for desktop */}
      <div className="printable-models__grid">
        {filteredModels.map((model) => (
          <DesignerModel key={model.id} {...model} lazyLoad />
        ))}
      </div>

      <ModelScrollList models={models} />

      <BrowseAllButton href={link} className="printable-browse-all-mobile" text={buttonText} />
    </div>
  )
}

PrintModelsBase.propTypes = {
  models: array.isRequired,
  title: string.isRequired,
  mobileTitle: string,
  description: string.isRequired,
  link: string.isRequired,
  className: string,
  buttonText: string.isRequired,
  isHydrated: bool,
}

export default PrintModelsBase
